import router from '@/router'
import store from '@/store'
import InfoService from '@/services/InfoService'
import { setCookie } from '@/utils/cookie'
import { trackEvent } from '@/utils/tracking'
import {
  ORIGIN_PLATFORM_COOKIE_NAME,
  RESELLER_ROLE_TYPE,
  TRACKING_ID_COOKIE_NAME
} from '@/constants'
import { SET_REDIRECT_URI, UPDATE_HAS_TEMP_PASSWORD } from '@/store/mutationTypes'
import { getProductName } from '@/utils/url'

export async function handlePostLoginResult (res) {
  const productName = getProductName()
  if (res.redirect_uri) {
    store.commit(SET_REDIRECT_URI, res.redirect_uri)
  }
  let userInfo = null
  if (productName !== 'mtalk-app') {
    userInfo = await InfoService.infoUser()
    if (userInfo?.tracking_id) {
      setCookie(TRACKING_ID_COOKIE_NAME, userInfo.tracking_id)
    }
    if (userInfo?.origin_platform) {
      setCookie(ORIGIN_PLATFORM_COOKIE_NAME, userInfo.origin_platform)
    }
  }

  if (productName !== 'mtalk-app' && productName !== 'riv') {
    trackEvent('login', {
      email_address: userInfo.email,
      phone_number: userInfo.phones?.[0]
    })
    const info = await InfoService.fetchContractInfo()
    if (!info.latest_contract) {
      router.push('accept-contract')
      return
    }
  }

  if (productName === 'riv') {
    if (!userInfo.roles?.some(role => role.type === RESELLER_ROLE_TYPE)) {
      throw new Error({ key: 'pages.login.errorBadUserReseller' })
    }

    if (userInfo.temp_password === '1') {
      store.commit(UPDATE_HAS_TEMP_PASSWORD, true)
      router.push('change-password').catch(() => {})
      return
    }
  }

  return store.dispatch('goToRedirectUri')
}
